// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, buscas, catálogo e os carregadores
// das telas. Outro módulo usa a `public.ts`.
export { loadApprovalsMessages } from './approvals.catalog';
export { approvalsCreditNoteScreen, approvalsHubScreen, approvalsOperatorsScreen } from './approvals.screen';
export { APPROVALS_PATH, approvalsSearch, creditNoteApprovalsSearch, DEFAULT_IB_TYPE, legacyInternetBankingSearch, operatorsSearch } from './approvals.search';

/** Cada tela no próprio chunk. */
export const loadApprovalsHubScreen = () => import('./screens/approvals-hub-screen');
export const loadApprovalsOperatorsScreen = () => import('./screens/operators-screen');
export const loadApprovalsCreditNoteScreen = () => import('./screens/credit-note-approvals-screen');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadApprovalsGuides = () => import('./approvals.guide');
